module.exports = __webpack_public_path__ + "static/media/GLORY_8000.6907b5ad.jpg";